const links = document.getElementsByClassName('smooth-anchor-link');

for (var i = 0; i < links.length; i++) {
    links[i].addEventListener('click', (e) => {
        e.preventDefault();
        var targetId = e.target.getAttribute('href');
        var targetElement = document.querySelector(targetId);
        if (targetElement) {
            var targetPosition = targetElement.getBoundingClientRect().top;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth',
            });
        }
    });
}
